<div class="category-container">
    <!-- Categories -->
    <div *ngFor="let category of categories" class="category-item">
        <div class="category-header">
            <input type="checkbox"
                   [id]="category.key"
                   [checked]="selectedData[category.key] === true"
                   (change)="toggleCategorySelection(category.key, $event.target.checked)" />
            <label [for]="category.key" class="category-label">
                {{ category.label }}
            </label>
        </div>

        <!-- Subcategories for Documents -->
        <div *ngIf="category.key === 'documents' && selectedData['documents'] !== false"
             class="subcategory-container">
            <div *ngFor="let subCategory of documentSubCategories" class="subcategory-item">
                <input type="checkbox"
                       [id]="subCategory.key"
                       [checked]="getSubCategorySelection(subCategory.key)"
                       (change)="setSubCategorySelection(subCategory.key, $event.target.checked)" />
                <label [for]="subCategory.key">{{ subCategory.label }}</label>
            </div>
        </div>
    </div>

    <!-- Export Button -->
    <button class="btn btn-primary export-btn" (click)="exportData()">Export Data</button>
</div>
